<script lang="ts" setup>
import AccordionCard from '~/components/cards/AccordionCard.vue'
import JsonApiHelper from '~/helpers/json-api-helper'
import type { CategoryFaq } from '~/types/faqs'

const props = defineProps<{
  categoryId: string
}>()

const messages = {
  failedToGetCategoryFaqs: 'Не удалось получить вопросы и ответы категории.'
}

const { $apiHelper, $toast } = useNuxtApp()

const categoryFaqsKey = computed(() => `category-faqs-${props.categoryId}`)

const { data: categoryFaqsData, status: categoryFaqsStatus } = await useLazyAsyncData(categoryFaqsKey, loadCategoryFaqsData)

async function loadCategoryFaqsData (): Promise<CategoryFaq[]> {
  const params = { 'filter[categoryId]': props.categoryId, 'page[size]': 50 }

  try {
    const response = await $apiHelper.categoryFaqs.getCategoryFaqs(params)

    return JsonApiHelper.denormalizeResponse(response).data
  } catch (error) {
    console.error(error)

    $toast.error(messages.failedToGetCategoryFaqs)

    throw error
  }
}
</script>

<template>
  <div v-if="categoryFaqsStatus === 'success' && categoryFaqsData?.length">
    <h2>Ответы на&nbsp;часто задаваемые вопросы</h2>

    <div class="flex flex-col space-y-6">
      <AccordionCard v-for="x in categoryFaqsData" :key="x.attributes.question">
        <template #trigger>
          <h3 class="!mb-0 text-xl">
            {{ x.attributes.question }}
          </h3>
        </template>
        <template #content>
          <div v-html="x.attributes.answerHtml" />
        </template>
      </AccordionCard>
    </div>
  </div>
</template>
